import BEM from '../../../../bem';

const classes = BEM.with('ScheduleMessageStatus');

interface StatusProps {
  isAutomated?: boolean;
  smsOptedOut?: boolean;
  status: string;
}

const Status = ({ isAutomated, smsOptedOut, status }: StatusProps) => {
  let statusText: string;
  let statusSlug: string;

  if (status === 'queued') {
    if (isAutomated) {
      statusText = 'automated';
      statusSlug = 'isAutomatedMessage';
    } else {
      statusText = 'scheduled';
      statusSlug = 'scheduled';
    }
  } else if (status === 'sent_sms') {
    statusText = 'sent';
    statusSlug = 'sent';
  } else if (status) {
    if (typeof status !== 'string') {
      return null;
    } else {
      statusText = status;
      statusSlug = status.replace(/\s/g, '-');
    }
  } else {
    return null;
  }

  return (
    <div className={classes('')}>
      {smsOptedOut && (
        <div className={classes('optedOutContainer')}>
          <b>Opted out</b>
          <br />
          via SMS
        </div>
      )}
      {!smsOptedOut && (
        <div className={classes('statusPill', { [statusSlug]: true })}>{statusText}</div>
      )}
    </div>
  );
};

export default Status;
